import { Component, OnInit } from '@angular/core';
import { AlertService } from '../../services/alert.service';
import { Alert, AlertType } from '../../classes/alert';
import { reverseFlyInOut } from '../../classes/animations';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-notify-message',
    templateUrl: './notify-message.component.html',
    styleUrls: ['./notify-message.component.css'],
    animations: [reverseFlyInOut]
})
export class NotifyMessageComponent implements OnInit {

    alerts: Alert[] = [];

    constructor(
        private alertService: AlertService,
        private sanitizer: DomSanitizer,
        private translate: TranslateService
    ) { }

    ngOnInit() {
        this.alertService.getNotif().subscribe((alert: Alert) => {
            if (!alert) {
                // clear alerts when an empty alert is received
                this.alerts = [];
                return;
            }

            /*if (this.alerts.length > 0 && this.alerts[0].type === alert.type) {
                this.removeAlert(this.alerts[0]);
            }*/
            this.alerts.push(alert);


            // autoremove after [alert.removedAfter] milliseconds, or default 6 seconds
            setTimeout(function () {
                if (this.alerts.length > 0) {
                    this.removeAlert(alert);
                }
            }.bind(this), alert.removedAfter);
        });
    }

    removeAlert(alert: Alert) {
        this.alerts = this.alerts.filter(x => x !== alert);
    }

    removeAlerts() {
        this.alerts = [];
    }

    cssClass(alert: Alert) {
        if (!alert) {
            return;
        }

        // return css class based on alert type
        switch (alert.type) {
            case AlertType.Success:
                return 'fa fa-lg fa-check text-success';
            case AlertType.Error:
                return 'fa fa-lg fa-times text-danger';
            case AlertType.Info:
                return 'fa fa-lg fa-info text-info';
            case AlertType.Warning:
                return 'fa fa-lg fa-exclamation-triangle text-warning';
            case AlertType.Publish:
                return 'fa fa-lg fa-arrow-up text-success';
            case AlertType.Unpublish:
                return 'fa fa-lg fa-arrow-down text-danger';
        }
    }

}
